import { FileUploadValidation } from './FileUpload.types';

export const isAcceptableUploadFile = (
	file: File,
	{
		allowedExtensions,
		allowedMimeTypes
	}: Pick<FileUploadValidation, 'allowedExtensions' | 'allowedMimeTypes'>
): boolean => {
	const lowerName = file.name.toLowerCase();
	if (allowedExtensions.some((extension) => lowerName.endsWith(extension))) {
		return true;
	}

	const mime = file.type.toLowerCase();
	return mime !== '' && allowedMimeTypes.has(mime);
};
